// Traduce los errores que devuelve el back en el flujo MFA
// (ValidateMFAView y ResendMFAView en smart-v4-back) a claves de i18n.
const KEYS = {
	'invalid_token': 'mfa.errors.invalid_token',
	'expired_token': 'mfa.errors.expired_token',
	'Token is invalid or expired': 'mfa.errors.expired_token',
	'temp_token is required': 'mfa.errors.invalid_token',
	'OTP not found': 'mfa.errors.otp_not_found',
	'Process Mfa not found': 'mfa.errors.otp_not_found',
	'OTP expired': 'mfa.errors.otp_expired',
	'Incorrect code': 'mfa.errors.incorrect_code',
	'Too many attempts': 'mfa.errors.too_many_attempts',
	'You must wait before resending the code': 'mfa.errors.wait_resend',
	'LLimit of resends reached': 'mfa.errors.resend_limit' // el typo viene del back
}

// Errores que invalidan el temp_token: no sirve reintentar el código, hay que
// volver a la pantalla de login.
const RESTART = [
	'invalid_token',
	'expired_token',
	'Token is invalid or expired',
	'temp_token is required',
	'OTP not found',
	'Process Mfa not found',
	'Too many attempts',
	'LLimit of resends reached'
]

const getError = (err) => err?.response?.data?.error

export const mfaErrorKey = (err) => KEYS[getError(err)] || 'error'

export const mfaNeedsRestart = (err) => RESTART.includes(getError(err))
